'use client';
import { startTimer } from '#pplx/frontend/metrics/browser.js';
import { createContext, useContext, useEffect } from 'react';
export const pageTimer = {
    startTime: -1,
    timer: startTimer(),
};
export const markedModules = {
    startTime: -1,
    modules: new Set(),
};
export const PerformanceContext = createContext({
    markTTV: () => { },
    addPageTiming: () => { },
    getPageStartTime: () => 0,
    getPageTimer: () => startTimer(),
    addPageTimingOnce: () => { },
});
PerformanceContext.displayName = 'PerformanceContext';
function useMarkTTV() {
    const { markTTV } = useContext(PerformanceContext);
    return markTTV;
}
export function useGetPageStartTime() {
    const { getPageStartTime } = useContext(PerformanceContext);
    return getPageStartTime;
}
export function useGetPageTimer() {
    const { getPageTimer } = useContext(PerformanceContext);
    return getPageTimer;
}
export const PagePerformanceContext = createContext({
    markTTV: () => { },
});
PagePerformanceContext.displayName = 'PagePerformanceContext';
export function useMarkModuleTTV() {
    const { markTTV } = useContext(PagePerformanceContext);
    return markTTV;
}
export function useMarkPageTTVOnMount(opts = {}) {
    const markTTV = useMarkTTV();
    useEffect(() => {
        if (opts.skip) {
            return;
        }
        markTTV();
    }, [opts.skip, markTTV]);
}
export function useMarkModuleTTVOnMount(module, opts = {}) {
    const markModuleTTV = useMarkModuleTTV();
    useEffect(() => {
        if (opts.skip) {
            return;
        }
        markModuleTTV(module);
    }, [markModuleTTV, module, opts.skip]);
}
//# sourceMappingURL=PerformanceProviderShared.js.map